enum Identity {
  PASSING = 'PASSING',
  RESIDENT = 'RESIDENT',
  TOURIST = 'TOURIST',
}

export default Identity;
